import type {WixCodeConnectionItem, CompRef} from '@wix/document-services-types'
import _ from 'lodash'

export const getWixCodeConnectionItem = (currentConnections: any): WixCodeConnectionItem | undefined => {
    return _.find(currentConnections, {type: 'WixCodeConnectionItem'})
}
export const findConnectionByContext = (compConnections: any, context?: CompRef | null) => {
    return context
        ? _.find(compConnections, {controllerRef: {id: context.id}})
        : getWixCodeConnectionItem(compConnections)
}
export const getNicknameFromConnectionList = (compConnections: any, context?: CompRef | null): string | undefined => {
    const connectionItem = findConnectionByContext(compConnections, context)
    if (connectionItem) {
        return connectionItem.role
    }
}
